// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ExternessystemListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheExternesystemeQuery = {
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheExternesysteme(): (
  query: SucheExternesystemeQuery
) => Promise<ExternessystemListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) =>
      (await getAPI()).externesysteme.sucheExternesysteme({ ...query }),
    [getAPI]
  );
}
